var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block cms-block--typography cms-block-text",class:_vm.block.value.content_align.toLowerCase()},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.block.value.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }